// Chart.js config factories for the Soundstats dashboard — Lyve green theme.
// Return plain config objects {type, data, options} consumed by ChartCanvas.

import { compact } from './soundstatsHelpers';

export const FONT = "'DM Sans', sans-serif";
const TICK = 'rgba(255,255,255,.42)';
const GRID = 'rgba(255,255,255,.05)';
const BORDER = 'rgba(255,255,255,.06)';

export function baseOptions() {
  return {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          color: 'rgba(255,255,255,.66)', font: { family: FONT, size: 11 },
          boxWidth: 12, boxHeight: 12, usePointStyle: true, pointStyle: 'circle',
        },
      },
      tooltip: {
        backgroundColor: '#161616', borderColor: 'rgba(255,255,255,.14)', borderWidth: 1,
        titleFont: { family: FONT, weight: '700' }, bodyFont: { family: FONT },
        padding: 12, cornerRadius: 8, titleColor: '#fff', bodyColor: '#b2b9b0',
      },
    },
    scales: {
      x: { grid: { color: GRID }, ticks: { color: TICK, font: { family: FONT, size: 10.5 } }, border: { color: BORDER } },
      y: { grid: { color: GRID }, ticks: { color: TICK, font: { family: FONT, size: 10.5 } }, border: { color: BORDER } },
    },
  };
}

function merge(target, extra) {
  if (!extra) return target;
  return Object.assign({}, target, extra, {
    scales: Object.assign({}, target.scales, extra.scales || {}),
    plugins: Object.assign({}, target.plugins, extra.plugins || {}),
  });
}

export function lineConfig(labels, datasets) {
  const ds = datasets.map(d => {
    const color = d.color;
    return {
      label: d.label, data: d.data, borderColor: color, backgroundColor: color + '22',
      borderWidth: 2.5, pointRadius: 2.5, pointBackgroundColor: color, pointBorderColor: '#040504',
      pointBorderWidth: 1.5, tension: 0.35, fill: false, spanGaps: true,
    };
  });
  return {
    type: 'line',
    data: { labels, datasets: ds },
    options: merge(baseOptions(), {
      interaction: { mode: 'index', intersect: false },
      plugins: { legend: { display: ds.length > 1 } },
      scales: { y: { ticks: { callback: compact } } },
    }),
  };
}

export function horizBarConfig(labels, values) {
  return {
    type: 'bar',
    data: {
      labels,
      datasets: [{
        data: values,
        backgroundColor: 'rgba(0,220,73,.7)',
        hoverBackgroundColor: '#00dc49',
        borderColor: '#00dc49',
        borderWidth: 1,
        borderRadius: 6,
      }],
    },
    options: merge(baseOptions(), {
      indexAxis: 'y',
      plugins: { legend: { display: false } },
      scales: {
        x: { ticks: { callback: compact } },
        y: { ticks: { color: 'rgba(255,255,255,.55)', font: { family: FONT, size: 10.5 } }, grid: { display: false } },
      },
    }),
  };
}

export function doughnutConfig(labels, values) {
  const palette = ['#00dc49', '#00dc49', '#00dc49', '#00dc49', '#6AA8FF', '#FFB020', '#FF5252', '#22d3ee'];
  return {
    type: 'doughnut',
    data: {
      labels,
      datasets: [{ data: values, backgroundColor: palette.map(c => c + 'dd'), borderColor: '#0b0d0b', borderWidth: 2, hoverOffset: 6 }],
    },
    options: merge(baseOptions(), {
      cutout: '62%',
      plugins: { legend: { position: 'bottom' } },
      scales: {},
    }),
  };
}

export function releasesBarConfig(yKeys, counts) {
  return {
    type: 'bar',
    data: {
      labels: yKeys,
      datasets: [{ data: yKeys.map(k => counts[k]), backgroundColor: 'rgba(0,220,73,.6)', hoverBackgroundColor: '#00dc49', borderColor: '#00dc49', borderWidth: 1, borderRadius: 6 }],
    },
    options: merge(baseOptions(), {
      plugins: { legend: { display: false } },
      scales: {
        y: { ticks: { stepSize: 1, callback: v => (Math.floor(v) === v ? v : '') } },
      },
    }),
  };
}

export function horizBarPaletteConfig(labels, values, palette) {
  return {
    type: 'bar',
    data: {
      labels,
      datasets: [{
        data: values,
        backgroundColor: palette.map(c => c + 'cc'),
        hoverBackgroundColor: palette,
        borderColor: palette,
        borderWidth: 1,
        borderRadius: 6,
      }],
    },
    options: merge(baseOptions(), {
      indexAxis: 'y',
      plugins: { legend: { display: false } },
      scales: {
        x: { ticks: { callback: compact } },
        y: { ticks: { color: 'rgba(255,255,255,.55)', font: { family: FONT, size: 10.5 } }, grid: { display: false } },
      },
    }),
  };
}
